import TemplatePreview from './template_preview'
import connect from './connect'

export default connect(TemplatePreview)
